import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'

import { coursePath } from 'libs/paths'
import Image from 'components/LegacyImage'
import Link from 'components/Link'

const InstructorInfo = () => {
  const { course } = useStaticData()
  const { t } = useTranslation('@mc/next')

  return (
    <section className='mc-py-10 mc-text--center mc-text-sm--left'>
      <div className='row offset-lg-1'>
        <div className='col-12 col-sm-3'>
          <Image
            alt=''
            className='mc-corners--circle'
            height={128}
            src={course.primary1x1}
            width={128}
          />
        </div>
        <div className='col-12 col-sm-9'>
          <p className='mc-text--bold mc-opacity--muted mc-text--uppercase mc-text-small mc-mb-2'>
            {t('lesson.details.info.title')}
          </p>
          <h2 className='mc-text--bold mc-text--uppercase mc-text-h4 mc-mb-4'>
            {course.instructorName}
          </h2>
          <p className='mc-mb-6'>{course.marketingCmColumn}</p>
          <Link
            className='c-button c-button--tertiary c-button--md'
            href={coursePath(course.slug)}
            passHref
          >
            {t('lesson.details.info.link')}
          </Link>
        </div>
      </div>
    </section>
  )
}

export default InstructorInfo
